import type { Rect } from "@yjsgames/phaser-ui/panel-content";

export const SYNERGY_INFO_PANEL_W = 322;
export const SYNERGY_INFO_PANEL_H = 324;
export const SYNERGY_INFO_TARGET_CARD_W = 56;
export const SYNERGY_INFO_TARGET_CARD_H = 62;
export const SYNERGY_INFO_TARGET_ICON_SIZE = 30;
export const SYNERGY_INFO_TARGET_STEP = 74;
export const SYNERGY_INFO_ICON_SIZE = 42;

export interface SynergyInfoPopupLayout {
  readonly panel: Rect;
  readonly title: Rect;
  readonly glyph: Rect;
  readonly grade: Rect;
  readonly conditionLabel: Rect;
  readonly targetCards: readonly Rect[];
  readonly effectLabel: Rect;
  readonly effectText: Rect;
  readonly highlightButton: Rect;
}

export function computeSynergyInfoPopupLayout(
  cx: number,
  top: number,
  targetCount: number,
): SynergyInfoPopupLayout {
  const panel: Rect = {
    x: cx - SYNERGY_INFO_PANEL_W / 2,
    y: top,
    width: SYNERGY_INFO_PANEL_W,
    height: SYNERGY_INFO_PANEL_H,
  };
  const title: Rect = {
    x: cx - (SYNERGY_INFO_PANEL_W - 58) / 2,
    y: top + 18,
    width: SYNERGY_INFO_PANEL_W - 58,
    height: 40,
  };
  const glyph: Rect = {
    x: cx - SYNERGY_INFO_ICON_SIZE / 2,
    y: top + 66,
    width: SYNERGY_INFO_ICON_SIZE,
    height: SYNERGY_INFO_ICON_SIZE,
  };
  const grade: Rect = {
    x: cx - SYNERGY_INFO_PANEL_W / 2,
    y: top + 112,
    width: SYNERGY_INFO_PANEL_W,
    height: 16,
  };
  const conditionLabel: Rect = {
    x: cx - SYNERGY_INFO_PANEL_W / 2,
    y: top + 139,
    width: SYNERGY_INFO_PANEL_W,
    height: 14,
  };
  const count = Math.max(1, targetCount);
  const startX = cx - ((count - 1) / 2) * SYNERGY_INFO_TARGET_STEP;
  const targetCards = Array.from({ length: count }, (_, i) => ({
    x: startX + i * SYNERGY_INFO_TARGET_STEP - SYNERGY_INFO_TARGET_CARD_W / 2,
    y: top + 156,
    width: SYNERGY_INFO_TARGET_CARD_W,
    height: SYNERGY_INFO_TARGET_CARD_H,
  }));
  const effectLabel: Rect = {
    x: cx - SYNERGY_INFO_PANEL_W / 2,
    y: top + 228,
    width: SYNERGY_INFO_PANEL_W,
    height: 14,
  };
  const effectText: Rect = {
    x: cx - (SYNERGY_INFO_PANEL_W - 44) / 2,
    y: top + 250,
    width: SYNERGY_INFO_PANEL_W - 44,
    height: 42,
  };
  const highlightButton: Rect = {
    x: cx - 58,
    y: top + 296,
    width: 116,
    height: 20,
  };
  return { panel, title, glyph, grade, conditionLabel, targetCards, effectLabel, effectText, highlightButton };
}
